<div class="cancel-form">
  <label for="cancelReason">
    {{ 'return_exception.cancel_dialog.reason_label' | translate }}
  </label>
  <textarea
    id="cancelReason"
    pTextarea
    rows="4"
    class="w-full"
    [ngModel]="cancelReason()"
    (ngModelChange)="cancelReason.set($event)"
    [placeholder]="'return_exception.cancel_dialog.reason_placeholder' | translate"
  ></textarea>
  <div class="actions">
    <app-button
      type="secondary"
      [outlined]="true"
      [label]="'common.actions.cancel' | translate"
      (emitOnClick)="onCancel()"
    />
    <app-button
      severity="danger"
      [label]="'return_exception.actions.confirm_cancel' | translate"
      [disabled]="!cancelReason()?.trim()"
      (emitOnClick)="onConfirm()"
    />
  </div>
</div>
